export default "__VITE_ASSET__YaIyhAnW__"